import { PaginationListRequest } from "@shared/e-invoice";
import { ApplicationConnectType } from "./application-connect-type.enum";
import { ApplicationConnectStatus } from "./application-connect-status.enum";

export class ListApplicationConnectRequest extends PaginationListRequest {
    Application: ApplicationConnectType | null;
    Status: ApplicationConnectStatus | null;
    UserId: string;
}